import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable } from "rxjs";
import { HttpResponse, UserHttpResponse, AddEmployee, EmployeeDetail, ResourceReport, GenerateResourceReport } from "../interfaces";
import { CommonWebService } from "../public-api";
import { UserHttpService } from "./user-session.service";

@Injectable({
    providedIn: 'root'
})
export class EmployeeHttpService {
    public reloadEmployeeList$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public upcomingEvents$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

    constructor(
        private http: HttpClient,
        private userSessionService: UserHttpService,
        private readonly commonWebService: CommonWebService
    ) { }

    //get emmployee list
    public getEmployeeList(
        limit?: number,
        offset?: number,
        // emp_type?: string,
    ): Observable<HttpResponse<EmployeeDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userSessionService.userToken);

        // if (emp_type) {
        //     formData.append('emp_type', emp_type ? emp_type : "");
        // }
        if (limit !== undefined) {
            formData.append('limit', limit.toString());
        }
        if (offset !== undefined) {
            formData.append('offset', offset.toString());
        }
        return this.http.post<HttpResponse<EmployeeDetail[]>>('employees/employeeListing', formData);
    }

    //add new employee
    public addEmployee(body: AddEmployee, isEdit: boolean = false, id?: string,): Observable<HttpResponse<any[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('user_first_name', body.user_first_name);
        formData.append('user_last_name', body.user_last_name);
        formData.append('role', body.role);
        formData.append('emp_id', body.emp_id);
        formData.append('user_designation', body.user_designation);
        formData.append('dojoining', this.commonWebService.changeDateFormat(new Date(body.dojoining)));
        formData.append('user_mobile', body.user_mobile);
        formData.append('user_email', body.user_email);
        formData.append('user_skypeid', body.user_skypeid);
        formData.append('doBirth', this.commonWebService.changeDateFormat(new Date(body.doBirth)));
        formData.append('doanniversary', body.doanniversary ? this.commonWebService.changeDateFormat(new Date(body.doanniversary)) : '');
        formData.append('profile_picture', body.profile_picture ? this.commonWebService.getFormattedImageBase64(body.profile_picture) : '');
        formData.append('id_proof', body.id_proof ? this.commonWebService.getFormattedImageBase64(body.id_proof) : '');
        formData.append('manager_id', body.manager_id ? body.manager_id : '');
        formData.append('address1', body.address1 ? body.address1 : '');
        formData.append('address2', body.address2 ? body.address2 : '');
        formData.append('country', body.country ? body.country : '');
        formData.append('state', body.state ? body.state : '');
        formData.append('city', body.city ? body.city : '');
        formData.append('zipcode', body.zipcode ? body.zipcode : '');
        formData.append('user_department', body.user_department ? body.user_department : '');

        if (isEdit && id) {
            formData.append('employee_id', id);
        };
        return this.http.post<HttpResponse<any[]>>('employees/addEmployee', formData);
    }

    //get individual employee detail
    public getEmployeeDetail(id: string): Observable<UserHttpResponse<EmployeeDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('employee_id', id);
        return this.http.post<UserHttpResponse<EmployeeDetail[]>>('employees/employeeDetail', formData).pipe(
            map((response) => {
                if (response.data && response.data[0]) {
                    response.data[0].usr_doa = response.data[0].usr_doa && response.data[0].usr_doa !== '0000-00-00' ? response.data[0].usr_doa : '';
                    response.data[0].usr_dob = response.data[0].usr_dob && response.data[0].usr_dob !== '0000-00-00' ? response.data[0].usr_dob : '';
                    response.data[0].usr_doj = response.data[0].usr_doj && response.data[0].usr_doj !== '0000-00-00' ? response.data[0].usr_doj : '';
                    return response;
                } else {
                    return response;
                }
            })
        );
    }

    //delete employee
    public deleteEmployee(id: string): Observable<UserHttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('employee_id', id);
        return this.http.post<UserHttpResponse<any>>('employees/deleteEmployee', formData);
    }

    //import team
    public importTeam(file: File): Observable<UserHttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('csv_file', file ? file : '');
        return this.http.post<UserHttpResponse<any>>('employees/importEmployee', formData);
    }


    /*--Team Resources Report Detail---*/
    public getResourceReport(resourceId: string, data?: GenerateResourceReport): Observable<UserHttpResponse<ResourceReport[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('employee_id', resourceId);
        if (data?.reportfromDate) {
            formData.append('reportfromDate', data?.reportfromDate);
        }
        if (data?.reporttoDate) {
            formData.append('reporttoDate', data?.reporttoDate);
        }
        return this.http.post<UserHttpResponse<any>>('employees/employeeReport', formData);
    }

    /*-- Download REport--*/
    public downloadReport(resourceId: string, data?: GenerateResourceReport): Observable<UserHttpResponse<ResourceReport[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('employee_id', resourceId);
        if (data?.reportfromDate) {
            formData.append('reportfromDate', data?.reportfromDate);
        }
        if (data?.reporttoDate) {
            formData.append('reporttoDate', data?.reporttoDate);
        }
        return this.http.post<UserHttpResponse<any>>('employees/employeeReportDownload', formData);
    }

    public downloadReportDirectly(fileUrl: string) {
        return this.http.get(fileUrl, { responseType: 'blob' });
    }

    public updateWfhAllowed(empId: string, wfhStatus: string): Observable<UserHttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_customer_track_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('deviceType', 'WEB');
        formData.append('deviceToken', 'WEB');
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('emp_id', empId);
        formData.append('wfh_status', wfhStatus);
        return this.http.post<UserHttpResponse<any>>('employees/wfhAllowed', formData);
    }

    public fetchUpcomingBirthdays(): void {
        const userInfo = this.userSessionService.getUserInfo;
        const userToken = this.userSessionService.userToken;
        if (!userInfo || !userToken) return;
        let formData = new FormData();
        formData.append('user_id', userInfo.user_id);
        formData.append('customer_id', userInfo.usr_customer_track_id);
        formData.append('token', userToken);
        this.http.post<any>('employees/UpcomingLevBirthdayDetail', formData).subscribe({
            next: (res) => {
                this.upcomingEvents$.next(res && res.events && res.events.length > 0 ? res.events : []);
            },
            error: () => {
                this.upcomingEvents$.next([]);
            }
        });
    }

}